<div style="background-color:white; margin: 0; padding-bottom: 10px;">
  <table class="gt-reclass-table table table-condensed">
    <thead style="white-space:nowrap;">
      <tr>
        <th colspan="16" style="width: 100%;">Exams Rollover</th>
      </tr>
    </thead>
  </table>
  <br>

  <div class="row">
    <div class="col-md-2 col-md-offset-1">
      <label>Source Tax Year :</label>
      <div>
        <select class="form-control"
                [(ngModel)]="selectedTaxYear"
                (ngModelChange)="onTaxYearChange()">
          <option value="">-- Select --</option>
          @for (option of filteredTaxYearData; track $index) {
<option
                  [value]="option.CODE_DISP_DESC">
            {{ option.CODE_SHORT_DESC }}
          </option>
}
        </select>
      </div>
    </div>

    @if (scenarioRAF.length > 0) {
<div class="col-md-2 col-md-offset-1">
      <label>Source Scenario :</label>
      <div>
        <select class="form-control"
                [(ngModel)]="selectedScenario">
          @for (option of scenarioRAF; track $index) {
<option
                  [value]="option.VALUE">
            {{ option.LABEL }}
          </option>
}
        </select>
      </div>
    </div>
}

    @if (scenarioTargetRAF.length > 0) {
<div class="col-md-2 col-md-offset-1">
      <label>Target Scenario :</label>
      <div>
        <select class="form-control"
                [(ngModel)]="selectedTargetScenario">
          @for (option of scenarioTargetRAF; track $index) {
<option
                  [value]="option.VALUE">
            {{ option.LABEL }}
          </option>
}
        </select>
      </div>
    </div>
}
  </div>

  <br><br><br>

  <div class="row">
    <div class="col-md-3 col-md-offset-7">
      <button class="btn btn-info btn-sm" type="button"
              (click)="confirmRunExamsRollover()">
        Run Rollover
      </button>
      &nbsp;&nbsp;&nbsp;
      <button class="btn btn-default btn-sm reset-btn-no-hover" type="button"
              (click)="reset()">
        Reset
      </button>
    </div>
  </div>
</div>

@if (showConfirmDialog) {
<div class="confirmation-modal-overlay">
  <gtw-confirmation-modal
    [config]="confirmModalConfig"
    [visible]="false"
    (confirmed)="onConfirmYes()"
    (cancelled)="onConfirmNo()"
    (closed)="onConfirmNo()">
  </gtw-confirmation-modal>
</div>
}
